import { CollectionResponse } from '../types/api/CollectionsIndexTypes';
import { ProductResponseWithCollectionId } from '../types/api/ProductsIndexTypes';
import { User } from '../types/api/UsersTypes';
import { ProductOwnershipResponse } from '../types/api/OwnershipTypes';
import { LicenseTypeDetail, LicenseId } from '../types/api/LicenseTypesTypes';

import axios from 'axios';
import licenseHelpers from './licenseHelpers';
import algoliaHelpers from './algolia';

const purchase = async (
  items: CollectionResponse | ProductResponseWithCollectionId | Array<CollectionResponse | ProductResponseWithCollectionId>,
  user: User,
  queryId: string,
) => {
  const { pushCreditPurchaseEvent } = algoliaHelpers;
  const payload = Array.isArray(items)
    ? {
      product_ids: (items as Array<CollectionResponse | ProductResponseWithCollectionId>).map(item => item.id),
      user,
    }
    : {
      product_ids: [(items as CollectionResponse | ProductResponseWithCollectionId).id],
      user,
    };
  const result = await axios.post('/api/purchase', payload);
  await pushCreditPurchaseEvent(user, Array.isArray(items) ? items : [items], queryId);
  return result;
}

const determineNeedsRepurchase = (
  ownership: ProductOwnershipResponse | undefined,
  collection: CollectionResponse,
): boolean => {
  if (!ownership || collection.free_product) return false;
  return !ownership?.has_legitimate_license;
};

const determinePurchaseLicenseId = (
  ownership: ProductOwnershipResponse,
): LicenseId => {
  return ownership?.purchased_with_license?.id as LicenseId;
}

const determinePurchaseLicenseName = (
  licenseTypes: Array<LicenseTypeDetail>,
  ownership: ProductOwnershipResponse,
): string => {
  const { getLicenseNameById } = licenseHelpers;
  const { determinePurchaseLicenseId } = purchaseHelpers;
  const licenseId = determinePurchaseLicenseId(ownership);
  if (!licenseId) return 'Unspecified';
  return getLicenseNameById(licenseTypes, licenseId);
}

const determinePurchaseLicensedToName = (
  ownership: ProductOwnershipResponse,
): string => {
  return ownership?.purchased_by?.licensee || 'Unknown'
}

const purchaseHelpers = {
  purchase,
  determineNeedsRepurchase,
  determinePurchaseLicenseName,
  determinePurchaseLicenseId,
  determinePurchaseLicensedToName,
};

export default purchaseHelpers;
